import MenuItem from "@common/components/MenuItem";
import Select from "@common/components/Select";
import { TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { Protocol } from "@services/meetings/types";
import React, { PropsWithChildren } from "react";
import { useTranslation } from "react-i18next";

type CustomRoomFormProps = {
  name: string;
  protocol: Protocol;
  address: string;
  extension: string;
  setForm: Function;
};

const CustomRoomForm = (props: PropsWithChildren<CustomRoomFormProps>) => {
  const { name, protocol, address, extension, setForm } = props;
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction="column"
      sx={{ width: '100%', gap: "1rem",
        py: "0.5rem", }}
    >
      <TextField
        label={t("Site Name")}
        required
        value={name}
        onChange={(e) => setForm({ name: e.target.value })}
      />
      <Select
        label={t("Protocol")}
        value={protocol}
        onChange={(e) => setForm({ protocol: e.target.value as Protocol })}
      >
        <MenuItem value={Protocol.H323}>H.323</MenuItem>
        <MenuItem value={Protocol.SIP}>SIP</MenuItem>
      </Select>
      <TextField
        label={t("Address")}
        required
        value={address}
        onChange={(e) => setForm({ address: e.target.value })}
      />
      <TextField
        label={t("Extension")}
        value={extension}
        onChange={(e) => setForm({ extension: e.target.value })}
      />
      <Grid
        container
        sx={{ width: '100%', justifyContent: "flex-end",
          gap: "1rem", }}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default CustomRoomForm;
